import { render, staticRenderFns } from "./DeleteCommunicationsDialog.vue?vue&type=template&id=05c16a4d&scoped=true"
import script from "./DeleteCommunicationsDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCommunicationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c16a4d",
  null
  
)

export default component.exports